module.exports = __webpack_public_path__ + "img/contacto_16-9_640.a39392cc.jpg";